import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Components/Pages/Home/Home";
import Navigtion from "./Components/commanfile/Navigtion";
// import Service from "./Components/Pages/Service/Service";
import Photos from "./Components/Pages/Photos/Photos";
import Doctor from "./Components/Pages/Doctor/Doctor";
import Contactus from "./Components/Pages/ContactUS/Contactus";
import Footer from "./Components/commanfile/Footer";
import AboutHospital from "./Components/Pages/AboutUs/AboutHospital";
import Deaddiction from "./Components/Pages/Service/Deaddiction";
import Child from "./Components/Pages/Service/Child";
import Electrotherapy from "./Components/Pages/Service/Electrotherapy";
import Mentalillness from "./Components/Pages/Service/Mentalillness";
import Epilipsy from "./Components/Pages/Service/Epilipsy";
import Sexualhelth from "./Components/Pages/Service/Sexualhelth";
import Psycotherapy from "./Components/Pages/Service/Psycotherapy";
import Geriatric from "./Components/Pages/Service/Geriatric";
import { Blog1 } from "./Components/Pages/Blog/Blog1";
import Blog2 from "./Components/Pages/Blog/Blog2";
import Blog3 from "./Components/Pages/Blog/Blog3";
import Blog4 from "./Components/Pages/Blog/Blog4";
import Blog5 from "./Components/Pages/Blog/Blog5";
import Blog6 from "./Components/Pages/Blog/Blog6";


function App() {
  return (
    <>
      <Navigtion />
      <Routes>
        <Route path="/*" element={<Home />} />
        {/* <Route path="/Service" element={<Service />} /> */}
        <Route path="/Photos" element={<Photos />} />
        <Route path="/Doctor" element={<Doctor />} />
        <Route path="/AboutHospital" element={<AboutHospital />} />
        <Route path="/Contactus" element={<Contactus />} />
        <Route path="/Deaddiction" element={<Deaddiction />} />
        <Route path="/Child" element={<Child />} />
        <Route path="/Electrotherapy" element={<Electrotherapy />} />
        <Route path="/Mentalillness" element={<Mentalillness />} />
        <Route path="/Psycotherapy" element={<Psycotherapy />} />
        <Route path="/epilipsy" element={<Epilipsy  />} />
        <Route path="/Sexualhelth" element={<Sexualhelth />} />
        <Route path="/Geriatric" element={<Geriatric/>}/>
        <Route path="/Blog1" element={<Blog1/>}/>
        <Route path="/Blog2" element={<Blog2/>}/>
        <Route path="/Blog3" element={<Blog3/>}/>
        <Route path="/Blog4" element={<Blog4/>}/>
        <Route path="/Blog5" element={<Blog5/>}/>
        <Route path="/Blog6" element={<Blog6/>}/>


      </Routes>
      <Footer />
    </>
  );
}

export default App;
